export default __webpack_public_path__ + "static/feature1-be3ce72a2ac5ad41a91f60ef44408d12.png";